export default {"src":"/_next/static/media/logo_black.a001553f.svg","height":24,"width":75};